export enum EntityType {
  STORE = 'STORE',
  PLACE = 'PLACE',
  ORDER = 'ORDER',
  QUEUE = 'QUEUE',
  PRODUCT = 'PRODUCT',
  USER = 'USER',
}



// WEBPACK FOOTER //
// ./src/app/shared/enums/entity-type.enum.ts